import { useQuery } from "@tanstack/react-query";
import { useCookies } from "react-cookie"
import { WarehouseService } from "../api/warehouse.service";

export const useStats = () => {
    const [cookies] = useCookies(['access_key']);

    return useQuery({
        queryKey: ['stats'],
        queryFn: () => WarehouseService.fetchStats(cookies.access_key),
        retry: 1,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: "always"
    });
}